import { render, staticRenderFns } from "./UtentiLoggati.vue?vue&type=template&id=2a7b83fb&scoped=true&"
import script from "./UtentiLoggati.vue?vue&type=script&lang=js&"
export * from "./UtentiLoggati.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7b83fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Attivita\\SVILUPPO Laravel\\archilogy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a7b83fb')) {
      api.createRecord('2a7b83fb', component.options)
    } else {
      api.reload('2a7b83fb', component.options)
    }
    module.hot.accept("./UtentiLoggati.vue?vue&type=template&id=2a7b83fb&scoped=true&", function () {
      api.rerender('2a7b83fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/UtentiLoggati.vue"
export default component.exports